import {animated, useSpring} from '@react-spring/web';

export const AnimatedFitoImage = () => {
    const spinAndScaleProps = useSpring({
        loop: true,                      // Infinite loop
        to: [
            { transform: 'rotate(360deg) scale(1.2)' },
            { transform: 'rotate(0deg) scale(1)' },
        ],
        config: { duration: 3000 },      // Total animation duration
    });


    return (
        <animated.img
            src={'/fito/fito-half-happy.png'}
            alt="Animated Fito"
            style={{
                ...spinAndScaleProps,
                display: 'block',
                margin: '0 auto',
            }}
        />
    );
};